import { APP_COUNTRY, APP_VENDOR } from 'config';
import { AppCountry, AppVendor } from 'window.types';

type RenderForCountryAndVendorProps = {
  allowedCountries?: AppCountry[];
  allowedVendors?: AppVendor[];
  component: React.ComponentType;
};

export function RenderForCountryAndVendor({
  allowedCountries,
  allowedVendors,
  component: Component,
}: RenderForCountryAndVendorProps) {
  const isCountryAllowed = allowedCountries
    ? allowedCountries.includes(APP_COUNTRY)
    : true;
  const isVendorAllowed = allowedVendors
    ? allowedVendors.includes(APP_VENDOR)
    : true;

  if (isCountryAllowed && isVendorAllowed) {
    return <Component />;
  }

  return null;
}
